import request from '@/utils/request'
export const queryPage = '/icps/system/sign/settlement/engCycle/queryEngineeringPage'
export const internalTotalDownload = '/icps/system/sign/settlement/internalTotal/exportProduct'
//获取月报量 结算列表
export function queryMouthPage(data) {
  return request({
    url: '/icps/system/sign/settlement/engCycle/queryMouthPage',
    method: 'post',
    data
  })
}
//获取内审量 结算列表
export function queryInternalAuditPage(data) {
  return request({
    url: '/icps/system/sign/settlement/engCycle/queryInternalAuditPage',
    method: 'post',
    data
  })
}
//获取确认量 结算列表
export function querySurePage(data) {
  return request({
    url: '/icps/system/sign/settlement/engCycle/querySurePage',
    method: 'post',
    data
  })
}
//月报量-确认结算单-获取待处理数据
export function queryProductData(data) {
  return request({
    url: '/icps/system/settlement/engCycle/product/queryProductData',
    method: 'post',
    data
  })
}
//根据工程获取站点
export function getStationByCompanyId(data) {
  return request({
    url: '/icps/system/sign/settlement/engCycle/getStationByCompanyId',
    method: 'post',
    data
  })
}
//月报量-保存
export function saveSettleDetail(data) {
  return request({
    url: '/icps/system/settlement/engCycle/product/saveSettleDetail',
    method: 'post',
    data
  })
}
//内审量 确认量-保存
export function saveSettleDetailOther(data) {
  return request({
    url: '/icps/system/settlement/engCycle/other/saveSettleDetail',
    method: 'post',
    data
  })
}
//月报量-查看结算单
export function queryInternalSettleData(data) {
  return request({
    url: '/icps/system/sign/settlement/internalTotal/querySettleData',
    method: 'post',
    data
  })
}
//内审量-查看结算单
export function queryConfirmSettleData(data) {
  return request({
    url: '/icps/system/sign/settlement/confirmTotal/querySettleData',
    method: 'post',
    data
  })
}
// 过程核定量-查看结算单
export function queryProcessSettleData(data) {
  return request({
    url: '/icps/system/sign/settlement/processTotal/querySettleData',
    method: 'post',
    data
  })
}
// 内审  审核修改状态
export function updaetInternalSettleStatus(data) {
  return request({
    url: '/icps/system/sign/settlement/internalTotal/updaetSettleStatus',
    method: 'post',
    data
  })
}
//  确认  审核修改状态
export function updaetConfirmSettleStatus(data) {
  return request({
    url: '/icps/system/sign/settlement/confirmTotal/updaetSettleStatus',
    method: 'post',
    data
  })
}
//  过程核定量  审核修改状态
export function updateProcessSettleStatus(data) {
  return request({
    url: '/icps/system/sign/settlement/processTotal/updaetSettleStatus',
    method: 'post',
    data
  })
}
//月报量 确认结算单
export function saveProductData(data) {
  return request({
    url: '/icps/system/settlement/engCycle/product/saveProductData',
    method: 'post',
    data
  })
}
//月报量 生成结算
export function addCycle(data) {
  return request({
    url: '/icps/system/sign/settlement/engCycle/addCycle',
    method: 'post',
    data
  })
}
//月报量 删除
export function deleteCycle(data) {
  return request({
    url: '/icps/system/sign/settlement/engCycle/deleteCycle',
    method: 'post',
    data
  })
}
//内审量 删除
export function deleteSettleStatus(data) {
  return request({
    url: '/icps/system/sign/settlement/internalTotal/deleteSettleStatus',
    method: 'post',
    data
  })
}
//过程核定量 删除
export function deleteCycleProcess(data) {
  return request({
    url: '/icps/system/sign/settlement/engProcessCycle/deleteCycle',
    method: 'post',
    data
  })
}
//过程核定量 待审核删除
export function deleteSettleProcess(data) {
  return request({
    url: '/icps/system/sign/settlement/processTotal/deleteSettleStatus',
    method: 'post',
    data
  })
}
//获取工程交底信息
export function getDisClostDetail(data) {
  return request({
    url: '/icps/system/sign/cloudSell/disclose/getDisClostDetail',
    method: 'post',
    data
  })
}
//核对订单 查询
export function queryCheckDetailInternal(data) {
  return request({
    url: '/icps/system/sign/settlement/internal/queryPage',
    method: 'post',
    data
  })
}
//核对订单 保存
export function saveCheckDetailInternal(data) {
  return request({
    url: '/icps/system/sign/settlement/internal/saveOrUpdate',
    method: 'post',
    data
  })
}
//核对订单 删除
export function deleteDetailInternal(data) {
  return request({
    url: '/icps/system/sign/settlement/internal/deleteDetail',
    method: 'post',
    data
  })
}
//核对订单 查询
export function queryCheckDetailConfirm(data) {
  return request({
    url: '/icps/system/sign/settlement/confirm/queryPage',
    method: 'post',
    data
  })
}
//核对订单 保存
export function saveCheckDetailConfirm(data) {
  return request({
    url: '/icps/system/sign/settlement/confirm/saveOrUpdate',
    method: 'post',
    data
  })
}
//核对订单 删除
export function deleteDetailConfirm(data) {
  return request({
    url: '/icps/system/sign/settlement/confirm/deleteDetail',
    method: 'post',
    data
  })
}
//核对订单 查询 核定量
export function queryCheckDetailProcess(data) {
  return request({
    url: '/icps/system/sign/settlement/process/queryPage',
    method: 'post',
    data
  })
}
//核对订单 保存 核定量
export function saveCheckDetailProcess(data) {
  return request({
    url: '/icps/system/sign/settlement/process/saveOrUpdate',
    method: 'post',
    data
  })
}
//核对订单 删除 核定量
export function deleteDetailProcess(data) {
  return request({
    url: '/icps/system/sign/settlement/process/deleteDetail',
    method: 'post',
    data
  })
}
//内审量-生成结算
export function querySummaryDataInternal(data) {
  return request({
    url: '/icps/system/sign/settlement/internalTotal/querySummaryData',
    method: 'post',
    data
  })
}
//确认量-生成结算
export function querySummaryDataConfirm(data) {
  return request({
    url: '/icps/system/sign/settlement/confirmTotal/querySummaryData',
    method: 'post',
    data
  })
}
//过程核定量-生成结算
export function querySummaryDataProcess(data) {
  return request({
    url: '/icps/system/sign/settlement/processTotal/querySummaryData',
    method: 'post',
    data
  })
}
//内审量-保存
export function submitExamineInternal(data) {
  return request({
    url: '/icps/system/sign/settlement/internalTotal/submitExamine',
    method: 'post',
    data
  })
}
//确认量-保存
export function submitExamineConfirm(data) {
  return request({
    url: '/icps/system/sign/settlement/confirmTotal/submitExamine',
    method: 'post',
    data
  })
}
//确认量-保存
export function submitExamineProcess(data) {
  return request({
    url: '/icps/system/sign/settlement/processTotal/submitExamine',
    method: 'post',
    data
  })
}
//内审量-保存流程数据
export function addExamineDataInternal(data) {
  return request({
    url: '/icps/system/sign/settlement/internalTotal/addExamineData',
    method: 'post',
    data
  })
}
//确认量-保存流程数据
export function addExamineDataConfirm(data) {
  return request({
    url: '/icps/system/sign/settlement/confirmTotal/addExamineData',
    method: 'post',
    data
  })
}
//确认量-保存流程数据
export function addExamineDataProcess(data) {
  return request({
    url: '/icps/system/sign/settlement/processTotal/addExamineData',
    method: 'post',
    data
  })
}
//审批常用人获取
export function queryRecentUser(params) {
  return request({
    url: '/icps/system/sign/settlement/recentUser/queryRecentUser',
    method: 'get',
    params
  })
}
//审批常用人修改
export function addOrUpdateRecentUser(data) {
  return request({
    url: '/icps/system/sign/settlement/recentUser/addOrUpdateRecentUser',
    method: 'post',
    data
  })
}
//过程核定量列表
export function engProcessCycleQuery(data) {
  return request({
    url: '/icps/system/sign/settlement/engProcessCycle/queryPage',
    method: 'post',
    data
  })
}
//过程核定量 生成结算
export function engProcessCycleAdd(data) {
  return request({
    url: '/icps/system/sign/settlement/engProcessCycle/addCycle',
    method: 'post',
    data
  })
}
//过程核定量 确认结算单列表数据
export function engCycleProductData(data) {
  return request({
    url: '/icps/system/settlement/engProcessCycle/product/queryProductData',
    method: 'post',
    data
  })
}
//过程核定量 确认结算单列表数据
export function engCycleProductDataSave(data) {
  return request({
    url: '/icps/system/settlement/engProcessCycle/product/saveProductData',
    method: 'post',
    data
  })
}
//内审量获取已关联子工程
export function queryChildEngCycles(data) {
  return request({
    url: '/icps/system/sign/settlement/internalTotal/queryChildEngCycles',
    method: 'post',
    data
  })
}
//确认量获取已关联子工程
export function queryRelevanceCycles(data) {
  return request({
    url: '/icps/system/sign/settlement/confirmTotal/queryRelevanceCycles',
    method: 'post',
    data
  })
}
//内审量获取符合条件的子工程数据
export function queryEngCycleList(data) {
  return request({
    url: '/icps/system/sign/settlement/internalTotal/queryEngCycleList',
    method: 'post',
    data
  })
}
//根据工程获取期初数据
export function querySettleInitDataByCycleManageId(data) {
  return request({
    url: '/icps/engineering-settlement/querySettleInitDataByCycleManageId',
    method: 'post',
    data
  })
}
//获取汇总数据-内审量
export function querySettleDataTotal(data) {
  return request({
    url: '/icps/system/sign/settlement/internalTotal/querySettleDataTotal',
    method: 'post',
    data
  })
}
//获取核对明细单汇总数据-内审量
export function queryPageTotal(data) {
  return request({
    url: '/icps/system/sign/settlement/internal/queryPageTotal',
    method: 'post',
    data
  })
}
//获取汇总数据-确认量
export function querySettleDataTotalConfirm(data) {
  return request({
    url: '/icps/system/sign/settlement/confirmTotal/querySettleDataTotal',
    method: 'post',
    data
  })
}
//保存撤回原因-确认量
export function updateTotalRemarkConfirm(data) {
  return request({
    url: '/icps/system/sign/settlement/confirmTotal/updateTotalRemark',
    method: 'post',
    data
  })
}
//保存撤回原因-内审
export function updateTotalRemarkInternal(data) {
  return request({
    url: '/icps/system/sign/settlement/internalTotal/updateTotalRemark',
    method: 'post',
    data
  })
}
//确认量重置
export function confirmTotalDeleteData(data) {
  return request({
    url: '/icps/system/sign/settlement/confirmTotal/deleteData',
    method: 'post',
    data
  })
}